import { defineMessages } from 'react-intl';

const _default_1: {
	heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	message: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	imageAlt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	action: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	heading: {
		id: 'atlassian-studio-common.unknown-error-page.heading',
		defaultMessage: 'Something went wrong',
		description: 'Title for the generic error page',
	},
	message: {
		id: 'atlassian-studio-common.unknown-error-page.message',
		defaultMessage:
			'Try again later or check <Link>status.atlassian.com</Link> for the latest updates.',
		description: 'Message for the generic error page',
	},
	imageAlt: {
		id: 'atlassian-studio-common.unknown-error-page.imageAlt',
		defaultMessage: 'unknown error illustration',
		description: 'Alt text for the unknown error',
	},
	action: {
		id: 'atlassian-studio-common.unknown-error-page.action',
		defaultMessage: 'View status page',
		description: 'text for the action view status page button',
	},
});
export default _default_1;
